export enum ReportsDashboardGetters {
    GET_QUARTER_SUMMARY_CONTENT = 'GET_QUARTER_SUMMARY_CONTENT',
    GET_MONTH_INTERRUPTION_SUMMARY = 'GET_MONTH_INTERRUPTION_SUMMARY',
    GET_TOTAL_MONTH_INCIDENTS = 'GET_TOTAL_MONTH_INCIDENTS',
    GET_DATACENTER_BUILDINGS = 'GET_DATACENTER_BUILDINGS',
}
